import {Component, Inject, Input, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {PageErrorService} from '@app/pages/page-error/service/page-error.service';
import {PageErrorType} from '@app/pages/page-error/classes/page-error-type';
import {PageError} from '@app/pages/page-error/interface/page-error';
import {SiteSettingsService} from '@app/services/site-settings.service';
import {WINDOW} from '@app/services/window.service';
import {from, Subject} from 'rxjs';
import {takeUntil, tap} from 'rxjs/operators';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'error-content',
    imports: [CommonModule],
    templateUrl: './error-content.component.html',
    styleUrls: ['./error-content.component.scss']
})
export class ErrorContentComponent implements OnDestroy {
	public PageErrorType = PageErrorType;
	public siteTitle: string;
	@Input() mistake: PageError;
	private destroy$: Subject<void> = new Subject<void>();

	constructor(
		private router: Router,
		private pageErrorService: PageErrorService,
		private siteSettingsService: SiteSettingsService,
		@Inject(WINDOW) private window: Window,
	) {
		this.siteTitle = this.siteSettingsService.siteTitle;
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}

	public goToStories() {
		if (this.router.url === '/stories') {
			this.window.location.href = this.siteSettingsService.siteUrl;
		} else {
			from(this.router.navigate(['stories']))
				.pipe(
					tap(() => this.pageErrorService.remove()),
					takeUntil(this.destroy$)
				)
				.subscribe();
		}
	}
}
